__turbopack_context__.v({
  "optionButton": "ImportOptionsSection-module__br7kzG__optionButton",
  "optionCard": "ImportOptionsSection-module__br7kzG__optionCard",
  "optionCardAutomatic": "ImportOptionsSection-module__br7kzG__optionCardAutomatic",
  "optionCardManual": "ImportOptionsSection-module__br7kzG__optionCardManual",
  "optionContent": "ImportOptionsSection-module__br7kzG__optionContent",
  "optionIcon": "ImportOptionsSection-module__br7kzG__optionIcon",
  "optionTitle": "ImportOptionsSection-module__br7kzG__optionTitle",
  "sectionWrapper": "ImportOptionsSection-module__br7kzG__sectionWrapper",
});
